import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularUiCommonModule } from '../../submodules/angular-ui-common/angular-ui-common.module';
import { PublicAreaRoutingModule } from './public-area-routing.module';
import { PublicAreaComponent } from './components/public-area.component';
import { HomeComponent } from './components/home/home.component';

@NgModule({
  declarations: [
    PublicAreaComponent,
    HomeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
  
    // routing
    PublicAreaRoutingModule,

    // i18n
    TranslateModule,

    // app
    AngularUiCommonModule
  ],
  providers: [],
  exports: [                 //<- componenti da utilizzare anche fuori da questo modulo
    PublicAreaComponent
  ],
})
export class PublicAreaModule {
  constructor() {
    console.log('PublicAreaModule loaded.');
  }
}
